import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({ selector: '[allowNumberOnly]' })
export class AllowNumberOnlyDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace','Tab','ArrowLeft','ArrowRight','Delete','Home','End'];
    if (allowedKeys.indexOf(event.key) !== -1 || event.ctrlKey || event.metaKey) {
      return;
    }
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const text = (event.clipboardData || (window as any).clipboardData).getData('text');
    if (!/^[0-9]+$/.test(text)) {
      event.preventDefault();
    }
  }

  @HostListener('input')
  onInput() {
    const el = this.el.nativeElement;
    const cleaned = el.value.replace(/\D+/g, '');
    if (el.value !== cleaned) {
      el.value = cleaned;
      el.dispatchEvent(new Event('input'));
    }
  }
}

@Directive({ selector: '[allowDecimal]' })
export class AllowDecimalDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace','Tab','ArrowLeft','ArrowRight','Delete','Home','End'];
    if (allowedKeys.indexOf(event.key) !== -1 || event.ctrlKey || event.metaKey) {
      return;
    }
    if (event.key === '.') {
      if (this.el.nativeElement.value.includes('.')) {
        event.preventDefault();
      }
      return;
    }
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const text = (event.clipboardData || (window as any).clipboardData).getData('text');
    if (!/^\d*\.?\d*$/.test(text)) {
      event.preventDefault();
    }
  }

  @HostListener('input')
  onInput() {
    const el = this.el.nativeElement;
    let cleaned = el.value.replace(/[^0-9.]/g, '');
    const parts = cleaned.split('.');
    if (parts.length > 2) {
      cleaned = parts.shift() + '.' + parts.join('');
    }
    if (el.value !== cleaned) {
      el.value = cleaned;
      el.dispatchEvent(new Event('input'));
    }
  }
}
